<style scoped lang="scss">
.qualifiedStamp{
  position: absolute;
  margin-left: 1020px;
  margin-top: 10px;
  img{
    width: 150px;
  }
}
.tableView{
  width: 100%;
  border-bottom: 1px solid #E5E5E7;
  border-right: 1px solid #E5E5E7;
  border-spacing: 0;
  tr{
    td{
      border-left: 1px solid #E5E5E7;
      border-top: 1px solid #E5E5E7;
      font-size: 22px;
      text-align: center;
      padding: 10px;
      &.label{
        background: #f7f9fa;
      }
    }
  }
}
.cons{
  display: none;
}
.highlightCol{
  background: #f7f9fa;
}
  .wrap-compose{
    .banner{
      position: relative;
      .info{
        position: absolute;
        top:0;
        width:100%;
        height:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1{
          font-size: 46px;
          color:#fff;
        }
      }
      .classify{
        padding:20px;
        background: rgba(255,255,255,.9);
        width: 200px;
        height:300px;
        position: absolute;
        left:calc((100vw - 1200px) / 2);
        top:50%;
        transform: translateY(-50%);
        z-index: 9;
        .title{
          padding-bottom: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: bold;
          border-bottom: 1px solid #E4E6EA;
        }
        a{
          color:#333;
          &.active{
            color:#014492;
          }
        }
        li{
          margin-bottom: 20px;
        }
      }
    }
    .map{
      width:940px;
      margin: 40px auto;
    }
    .service{
      background: #F6FAFD;
      ul{
        display: flex;
        justify-content: space-around;
        padding:0 10%;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
    .container_service{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      flex-wrap: wrap;
      -ms-flex-pack: distribute;
      justify-content: space-around;
      text-align: left;
    }
    .container_shuoming{
      overflow: auto;
      li{
        margin-bottom: 10px;
      }
      li:last-child{
        margin-bottom: 0;
      }
    }
    .container_service li{
      margin-bottom: 10px;
      position: relative;
      padding-left: 20px;
      margin-left: 5%;
      font-size: 16px;
      font-weight: bold;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      color: #014492;
      flex: 0 0 16%;
    }
    .container_service li:before {
      content: '';
      width: 5px;
      height: 5px;
      background: #014492;
      border-radius: 50%;
      display: block;
      margin-top: 8px;
      position: absolute;
      left: 0;
    }
    .container_table{
      overflow: auto;
      margin-top: 20px;
      .left{
        float: left;
        width: 42%;
      }
      .right{
        float: right;
        width: 53%;
      }
    }
    .container_youshi{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: distribute;
      justify-content: space-around;
    }
    .container_banner1{
      .img{
        float: left;
        width: 45%;
      }
      .desc{
        float: left;
        text-indent: 0em;
        width: 45%;
        margin-left: 20px;
        margin-top: 8%;
      }
    }
  }
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 14px!important;
    }
    .mr42{
      margin-left: auto;
      margin-right: auto;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
    .wrap-compose .banner .info h1{
      font-size: 25px!important;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .cons{
      display: block!important;
    }
    .con{
      display: none!important;
    }
    .container_banner1{
      margin-bottom: 20px;
      .img{
        float: none!important;
        width: 100% !important;
      }
      .desc{
        float: none!important;
        text-indent: 0;
        width: 100% !important;
        margin-left: 0!important;
        margin-top: 2% !important;
      }
    }
    .container_service{
     display: block!important;
    }
    .container_shuoming{
      overflow: auto;
      li{
        margin-bottom: 10px;
      }
      li:last-child{
        margin-bottom: 0;
      }
    }
    .container_service li{
      margin-bottom: 10px;
      position: relative;
      padding-left: 20px;
      margin-left: 5%;
      font-size: 16px;
      font-weight: bold;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      color: #014492;
      flex: 0 0 16%;
    }
    .container_service li:before {
      content: '';
      width: 5px;
      height: 5px;
      background: #014492;
      border-radius: 50%;
      display: block;
      margin-top: 8px;
      position: absolute;
      left: 0;
    }
    .container_table{
      overflow: auto;
      margin-top: 20px;
      .left{
        float: none!important;
        width: 100% !important;
      }
      .right{
        margin-top: 20px;
        float: none!important;
        width: 100% !important;
      }
    }
    .table1{
      td{
        font-size: 12px;
      }
      th{
        font-size: 14px;
      }
    }
    .c-title{
      padding-top: 0!important;
      padding-bottom: 10px!important;
    }
    .container_youshi{
     display: block!important;
      li{
        margin-bottom: 20px;
        p{
          margin-left: auto;
          margin-right: auto;
          width: fit-content!important;
        }
      }
      li:last-child{
        margin-bottom: 0;
      }
    }
  }
</style>
<style>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .container_table .left .el-table th.el-table__cell.is-leaf{
    background: #d6ecf9;
  }
  .container_table .right .el-table th.el-table__cell.is-leaf{
    background: #3f556d;
    color: #fff;
  }

}
@media screen and (min-width: 641px){
  .container_table .left .el-table th.el-table__cell.is-leaf{
    background: #d6ecf9;
  }
  .container_table .right .el-table th.el-table__cell.is-leaf{
    background: #3f556d;
    color: #fff;
  }
}
</style>
<template>
  <!--  常规引物合成-->
  <div class="wrap wrap-compose">
    <div class="banner">
      <img src="@/assets/images/banner_3.png" class="img-fluid" alt="擎科生物-修饰引物合成服务
">
      <div class="container info">
        <h1 class="text-primary">修饰引物/探针合成</h1>
        <el-button type="primary" size="mini" class="mt20 mr42" @click="handleSynthesis()">立即合成</el-button>
        <el-button type="primary"  class="mt20 mr41" @click="handleSynthesis()">立即合成</el-button>
      </div>
      <div class="classify">
        <div class="title">寡核苷酸修饰</div>
        <ul>
          <!-- <li><router-link to="/tec/compose1">DNA合成</router-link></li> -->
          <li><router-link :to="handleJumpPath('/tec/compose2')" class="active">修饰引物/探针合成</router-link></li>
          <!-- <li><router-link :to="handleJumpPath('/tec/compose3')">RNA合成</router-link></li> -->
<!--          <li><router-link to="">探针设计</router-link></li>-->
        </ul>
      </div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" >
        <div class="con">
          <el-row type="flex" align="bottom" class="mt30">
            <el-col :span="12">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/banner1.png" class="img-fluid" alt="擎科生物-提供及时、准确的基因合成服务">
            </el-col>
            <el-col :span="12">
              <div class="required">
                <p style="font-size: 16px">　　擎科生物于北京和苏州布局了高质量修饰引物/探针的生产工厂——梓熙生物，产品涵盖900多款SKU，其中包括GMP级别的修饰引物/探针合成、DNA/RNA合成服务。</p>
                <p class="mt10" style="font-size: 16px">　　梓熙生物拥有符合生物医药诊断标准的全十万级部分万级的洁净生产车间，采用国际先进的合成技术，高质量的合成试剂，先进的自动化生产设备、严格的ISO&nbsp;13485质量控制体系，为全球分子诊断企业、基因检测企业、核酸药物企业等提供高标准、高质量的核心原料。</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="cons">
          <div class="container_banner1" style="overflow: auto">
            <div class="img">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/banner1.png" alt="" class="img-fluid">
            </div>
            <p class="desc">　　擎科生物于北京和苏州布局了高质量修饰引物/探针的生产工厂——梓熙生物，产品涵盖900多款SKU，其中包括GMP级别的修饰引物/探针合成、DNA/RNA合成服务。
              梓熙生物拥有符合生物医药诊断标准的全十万级部分万级的洁净生产车间，采用国际先进的合成技术，高质量的合成试剂，先进的自动化生产设备、严格的ISO&nbsp;13485质量控制体系，为全球分子诊断企业、基因检测企业、核酸药物企业等提供高标准、高质量的核心原料。</p>
          </div>
        </div>


<!--        <el-table-->
<!--          :data="pageData.decorateTable"-->
<!--          style="width: 100%"-->
<!--          :span-method="objectSpanMethod">-->
<!--          <el-table-column-->
<!--            prop="type"-->
<!--            label="类型"-->
<!--            width="150">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="modify"-->
<!--            label="修饰">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="纯化方式">-->
<!--            <template slot-scope="scope">-->
<!--              HPLC-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="目录价">-->
<!--            <el-table-column-->
<!--              prop="price1"-->
<!--              label="2OD">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="price2"-->
<!--              label=">2OD">-->
<!--              <template slot-scope="scope">-->
<!--                <span>询价</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
      </div>
      <div class="container">
        <div class="c-title">服务类型</div>
        <p class="desc">
          擎科生物可以提供修饰/标记引物、双淬灭荧光探针、锁核酸（LNA）、NGS引物、STR探针、FRET探针合成服务，修饰基团多达百余种，客户可根据需要进行选择，按照功能可划分为以下几类：
        </p>
        <div style="margin-top: 20px;overflow: auto">
          <ul class="container_service">
            <li>氨基修饰</li>
            <li>荧光基团</li>
            <li>淬灭基团</li>
            <li>连接化学基团</li>
            <li>间臂</li>
            <li>核苷酸碱基修饰</li>
            <li>简并碱基</li>
            <li>其他修饰</li>
          </ul>
        </div>
        <div class="container_table">
          <div class="left">
              <el-table
                border
                class="mt30"
                :data="tableData">
                <el-table-column
                  prop="wu"
                  align="center"
                  label="5'修饰">
                </el-table-column>
                <el-table-column
                  prop="san"
                  align="center"
                  label="3'修饰">
                </el-table-column>
                <el-table-column
                  prop="zhong"
                  align="center"
                  label="中间修饰">
                </el-table-column>
                <el-table-column
                  prop="jian"
                  align="center"
                  width="110px"
                  label="简并碱基代码">
                </el-table-column>
              </el-table>
          </div>
          <div class="right">
            <div class="right_top">
              <h3>常用荧光修饰基团</h3>
                  <el-table
                    border
                    :cell-style="cellStyle"
                    class="mt30"
                    :data="tableData2">
                    <el-table-column
                      prop="xiu"
                      align="center"
                      label="修饰">
                    </el-table-column>
                    <el-table-column
                      prop="wu"
                      align="center"
                      label="5'修饰">
                    </el-table-column>
                    <el-table-column
                      prop="san"
                      align="center"
                      label="3'修饰">
                    </el-table-column>
                    <el-table-column
                      prop="zhong"
                      align="center"
                      label="中间修饰">
                    </el-table-column>
                    <el-table-column
                      prop="cui"
                      width="110px"
                      align="center"
                      label="最大激发波长">
                    </el-table-column>
                    <el-table-column
                      prop="zui"
                      width="110px"
                      align="center"
                      label="最大发射波长">
                    </el-table-column>
                  </el-table>
            </div>
            <div class="right_center" style="margin-top: 20px;">
              <h3>常用淬灭修饰基团</h3>
              <el-table
                border
                class="mt30"
                :data="tableData1">
                <el-table-column
                  prop="xiu"
                  align="center"
                  label="修饰">
                </el-table-column>
                <el-table-column
                  prop="wu"
                  align="center"
                  label="5'修饰">
                </el-table-column>
                <el-table-column
                  prop="san"
                  align="center"
                  label="3'修饰">
                </el-table-column>
                <el-table-column
                  prop="zhong"
                  align="center"
                  label="中间修饰">
                </el-table-column>
                <el-table-column
                  prop="cui"
                  align="center"
                  width="120px"
                  label="淬灭范围">
                </el-table-column>
                <el-table-column
                  prop="zui"
                  align="center"
                  width="110px"
                  label="最大吸收波长">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="container" style="margin-top: 20px;">
        <div class="c-title">服务优势</div>
        <ul class="container_youshi">
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/营销网络.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">营销网络:</h4>
            <p style="width: 90px;text-align: justify">全国多个城市均有实验基地，近距离的提供服务</p>
          </li>
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/质量保证.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">质量保证:</h4>
            <p style="width: 90px;text-align: justify">毛细管凝胶电泳(CE)与质谱(MS)等分析</p>
          </li>
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/GMP.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">GMP：</h4>
            <p style="width: 90px;text-align: justify">10万级洁净生产车间</p>
          </li>
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/批间差.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">批间差：</h4>
            <p style="width: 90px;">单管大OD合成,标准化作业</p>
          </li>
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/质量体系.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">质量体系：</h4>
            <p style="width: 90px;">ISO&nbsp;13485认证,可溯源</p>
          </li>
          <li>
            <div class="img" style="margin-left: auto;margin-right: auto;width: fit-content;">
              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/定制化.png">
            </div>
            <h4 style="margin-top: 15px;margin-bottom: 10px;text-align: center;color: #164397">定制化：</h4>
            <p style="width: 90px;text-align: justify">定制合成,专人负责</p>
          </li>
        </ul>
      </div>
      <div class="container" style="margin-top: 20px;">
        <div class="c-title">质量控制</div>
        <p class="desc">我们可提供MS、HPLC、CE、全波长扫描、PAGE分析胶检测等多重定制化QC，1条修饰引物实测结果如下：</p>
        <div class="img" style="width: 100%;margin-top: 20px;">
          <el-table
            border
            :header-cell-style="tableHeaderStyleBig"
            :cell-style="tableCellStyleBig"
            class="mt30"
            :data="tableQualityData">
            <el-table-column
              prop="col1"
              align="center"
              label="样品名">
            </el-table-column>
            <el-table-column
              prop="col2"
              align="center"
              label="修饰类型">
            </el-table-column>
            <el-table-column
              prop="col3"
              align="center"
              label="理论分子量">
            </el-table-column>
            <el-table-column
              prop="col4"
              align="center"
              label="实测分子量">
            </el-table-column>
            <el-table-column
              prop="col6"
              align="center"
              label="纯化方式">
            </el-table-column>
            <el-table-column
              prop="col5"
              align="center"
              label="主峰面积比">
            </el-table-column>
          </el-table>
          <div :style="{marginTop: '40px'}">
            <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/质控数据.png" alt="" class="img-fluid">
          </div>
          <div :style="{marginTop: '40px'}">
<!--            <div class="qualifiedStamp">-->
<!--              <img src="@/assets/img/设备及原料/修饰合成/修饰引物合成/qualified.png" alt="">-->
<!--            </div>-->
            <table class="tableView">
              <tr>
                <td rowspan="2" class="label">检测标准</td>
                <td>MS:实测分子量和理论分子量相差≤±0.05%</td>
              </tr>
              <tr>
                <td>HPLC: HPLC纯化主峰面积≥95%</td>
              </tr>
              <tr>
                <td class="label">结论</td>
                <td>合格</td>
              </tr>
            </table>
          </div>



        </div>
      </div>
      <div class="container" style="margin-top: 20px;">
        <div class="c-title">服务说明</div>
        <ul class="container_shuoming">
          <li>纯化方式：提供脱盐到HPLC等多种纯化方式。</li>
          <li>交付内容：单管/96孔板/大离心管等（可定制）、干粉或溶液、COA文件、QC报告。</li>
          <li>极速反馈：技术支持反馈时间保证1小时以内。</li>
          <li>交付周期：修饰引物交期一般3-7天，需要根据您修饰类型与需求量评估，若您要合成未列出的修饰类型及其他长度的特殊引物，敬请咨询。</li>
        </ul>
      </div>
    </section>
    <qk-consult type="merging"  />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import bread from "@/components/bread"
import {tableHeaderStyle, tableHeaderStyleBig, tableCellStyleBig} from "@/settings/table";
import { blacklistsCheck } from '@/services/api.index';

export default {
  components:{
    bread
  },
  data() {
    return {
      tableHeaderStyle,
      tableHeaderStyleBig,
      tableCellStyleBig,
      tableQualityData: [
        {
          col1: 'ORF-1',
          col2: 'FAM,BHQ1',
          col3: '8214.1',
          col4: '8214',
          col5: '>95%',
          col6: 'HPLC',
        }
      ],
      tableData:[
        {
          wu:"5'Acrydite",
          san:"3'Azide(N3)",
          jian:'B=G,C,T',
          zhong:"5F-dU",
        },
        {
          wu:"5'Azide(N3)",
          san:"3'Biotin",
          jian:'D=A,G,T',
          zhong:"2-F-rA/C/G/U",
        },
        {
          wu:"5'BIO-TEG",
          san:"3'Biotin -TEG",
          jian:'H=A,C,T',
          zhong:"2'-O-Methyl -A/C/G/U",
        },
        {
          wu:"5'Biotin",
          san:"3'C3-FAM",
          jian:'K=G,T',
          zhong:"C7-NH2",
        },
        {
          wu:"5'C6-NH2",
          san:"3'C7-NH2",
          jian:'M=A,C',
          zhong:"deoxyInosine (dI)",
        },
        {
          wu:"5'C7-NH2",
          san:"3'CHCH",
          jian:'N=A,G,C,T',
          zhong:"deoxyUridine (dU)",
        },
        {
          wu:"5'CHCH",
          san:"3'Cholesteryl",
          jian:'R=A,G',
          zhong:"dSpacer",
        },
        {
          wu:"5'CHO",
          san:"3'DBCO",
          jian:'S=G,C',
          zhong:"dT-Azide",
        },
        {
          wu:"5'Cholesteryl",
          san:"3'ddC",
          jian:'V=A,G,C',
          zhong:"dT-Biotin",
        },
        {
          wu:"5'COOH",
          san:"3'Digoxin",
          jian:'W=A,T',
          zhong:"dT-DBCO",
        },
        {
          wu:"5'DBCO",
          san:"3'Ferrocene",
          jian:'Y=C,T',
          zhong:"dT-Digoxin",
        },
        {
          wu:"5'Digoxin",
          san:"3'Phosphorylation",
          jian:'',
          zhong:"dT-Ferrocene",
        },
        {
          wu:"5'ET-ROX",
          san:"3'SH",
          jian:'',
          zhong:"inverted-dT",
        },
        {
          wu:"5'ET-TAMRA",
          san:"3'Spacer C3",
          jian:'',
          zhong:"LNA-A/C/G/T",
        },
        {
          wu:"5'Ferrocene",
          san:"3'SS",
          jian:'',
          zhong:"m5C",
        },
        {
          wu:"5'PET",
          san:"",
          jian:'',
          zhong:"m5dC",
        },
        {
          wu:"5'Phosphorylation",
          san:"",
          jian:'',
          zhong:"m6A",
        },
        {
          wu:"5'SH",
          san:"",
          jian:'',
          zhong:"m6dA",
        },
        {
          wu:"5'Spacer 18",
          san:"",
          jian:'',
          zhong:"Phosphorothioate",
        },
        {
          wu:"5'Spacer C3",
          san:"",
          jian:'',
          zhong:"rA/C/G/U",
        },
        {
          wu:"5'SS",
          san:"",
          jian:'',
          zhong:"Spacer 12",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Spacer 18",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Spacer 9",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Spacer C12",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Spacer C3",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Spacer C6",
        },
        {
          wu:"",
          san:"",
          jian:'',
          zhong:"Xen",
        },
      ],
      tableData1:[
        {
          xiu:'Dabcyl',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'380 nm-530 nm',
          zui:'452 nm'
        },
        {
          xiu:'Eclipse',
          wu:'',
          san:'√',
          zhong:'',
          cui:'390 nm-625 nm',
          zui:'522 nm'
        },
        {
          xiu:'MGB',
          wu:'',
          san:'√',
          zhong:'',
          cui:'390 nm-625 nm',
          zui:'522 nm'
        },
        {
          xiu:'TAMRA',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'470 nm-560 nm',
          zui:'544 nm'
        },
        {
          xiu:'BHQ1',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'480 nm-580 nm',
          zui:'534 nm'
        },
        {
          xiu:'BHQ2',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'550 nm-650 nm',
          zui:'579 nm'
        },
        {
          xiu:'BHQ3',
          wu:'',
          san:'√',
          zhong:'',
          cui:'620 nm-730 nm',
          zui:'672 nm'
        },
      ],
      tableData2:[
        {
          xiu:'FAM',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'494 nm',
          zui:'518 nm'
        },
        {
          xiu:'TET',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'521 nm',
          zui:'536 nm'
        },
        {
          xiu:'JOE',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'520 nm',
          zui:'548 nm'
        },
        {
          xiu:'VIC',
          wu:'√',
          san:'',
          zhong:'',
          cui:'538 nm',
          zui:'554 nm'
        },
        {
          xiu:'HEX',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'535 nm',
          zui:'556 nm'
        },
        {
          xiu:'Quasar 570',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'547 nm',
          zui:'570 nm'
        },
        {
          xiu:'Cy3',
          wu:'√',
          san:'√',
          zhong:'√dT √骨架',
          cui:'552 nm',
          zui:'570 nm'
        },
        {
          xiu:'TAMRA',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'565 nm',
          zui:'580 nm'
        },
        {
          xiu:'ROX',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'585 nm',
          zui:'605 nm'
        },
        {
          xiu:'Texas Red',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'595 nm',
          zui:'615 nm'
        },
        {
          xiu:'Alexa Fluor 633',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'632 nm',
          zui:'647 nm'
        },
        {
          xiu:'Cy5',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'643 nm',
          zui:'667 nm'
        },
        {
          xiu:'Quasar 670',
          wu:'√',
          san:'√',
          zhong:'',
          cui:'647 nm',
          zui:'667 nm'
        },
        {
          xiu:'Cy5.5',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'684 nm',
          zui:'710 nm'
        },
        {
          xiu:'Cy7',
          wu:'√',
          san:'√',
          zhong:'√dT',
          cui:'750 nm',
          zui:'773 nm'
        },
      ]
    }
  },
  computed: {
    ...mapState(['pageData'])
  },
  methods: {
    //在method里面写上方法
    cellStyle({row, column, rowIndex, columnIndex}){
      if(rowIndex === 0 && columnIndex === 0){ //指定坐标
        return 'background:#23AB38;color:#fff'
      }
      else if(rowIndex === 1 && columnIndex === 0){ //指定坐标
        return 'background:#80BF35;color:#fff'
      }
      else if(rowIndex === 2 && columnIndex === 0){ //指定坐标
        return 'background:#80BF35;color:#fff'
      }
      else if(rowIndex === 3 && columnIndex === 0){ //指定坐标
        return 'background:#EEDF2F;color:#fff'
      }
      else if(rowIndex === 4 && columnIndex === 0){ //指定坐标
        return 'background:#EEDF2F;color:#fff'
      }
      else if(rowIndex === 5 && columnIndex === 0){ //指定坐标
        return 'background:#EEA530;color:#fff'
      }
      else if(rowIndex === 6 && columnIndex === 0){ //指定坐标
        return 'background:#EEA530;color:#fff'
      }
      else if(rowIndex === 7 && columnIndex === 0){ //指定坐标
        return 'background:#EEA530;color:#fff'
      }
      else if(rowIndex === 8 && columnIndex === 0){ //指定坐标
        return 'background:#C87E13;color:#fff'
      }
      else if(rowIndex === 9 && columnIndex === 0){ //指定坐标
        return 'background:#C87E13;color:#fff'
      }
      else if(rowIndex === 10 && columnIndex === 0){ //指定坐标
        return 'background:#C72522;color:#fff'
      }
      else if(rowIndex === 11 && columnIndex === 0){ //指定坐标
        return 'background:#C72522;color:#fff'
      }
      else if(rowIndex === 12 && columnIndex === 0){ //指定坐标
        return 'background:#C72522;color:#fff'
      }
      else if(rowIndex === 13 && columnIndex === 0){ //指定坐标
        return 'background:#C72522;color:#fff'
      }
      else if(rowIndex === 14 && columnIndex === 0){ //指定坐标
        return 'background:#7F7F80;color:#fff'
      }
      else{
        return ''
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 11,
            colspan: 1
          }
        } else if (rowIndex === 11) {
          return {
            rowspan: 26,
            colspan: 1
          }
        } else if (rowIndex === 37) {
          return {
            rowspan: 7,
            colspan: 1
          }
        } else if (rowIndex === 44) {
          return {
            rowspan: 13,
            colspan: 1
          }
        } else if (rowIndex === 57) {
          return {
            rowspan: 28,
            colspan: 1
          }
        } else if (rowIndex === 85) {
          return {
            rowspan: 10,
            colspan: 1
          }
        } else if (rowIndex === 95) {
          return {
            rowspan: 36,
            colspan: 1
          }
        }else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    handleJumpPath(path) {
      let queryPath = ''
      if(this.$route.path === '/tec/compose1') {
        queryPath = 'product=true'
      }
      Object.entries(this.$route.query).forEach(([key, value = '']) => {
        queryPath += `${key}=${value}`
      })
      return `${path}?${queryPath}`
    },
    async handleSynthesis() {
      const memberInfo = this.baseMethods.getLocalObj('memberInfo');
      const { data } = await blacklistsCheck(memberInfo.id, "PRIMER");
      if(!data)
        return this.$alert('下单异常,请电联4006683730转7','提示',{ confirmButtonText: '确认'});
      return this.$router.push('/tec/order_primer');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/compose_2.vue